import React, { ChangeEvent, useContext, useEffect, useState } from 'react';
import { Card, Grid, Tab, Tabs } from '@mui/material';
import { I_Folder } from 'src/interfaces/InstallationTypes';
import { UserContext } from 'src/contexts/userContext';
import { TabsContainerWrapper } from 'src/layouts/TabsContainerWrapper';
import AccessContextProvider from 'src/contexts/AccessContextProvider';
import { InstallationsContext } from 'src/contexts/InstallationsContextProvider';
import Access from '../ManageAccess/Access';
import { FormattedMessage } from 'react-intl';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import routes from '../../../Resources/routes.json';
import TreeInformation from './Information';
import { UserType } from '../../../interfaces/UserTypes';

interface singleFolderProps {
  current_folder: I_Folder;
}

function Folder(props: singleFolderProps) {
  const [currentTab, setCurrentTab] = useState<string>(undefined);
  const [formValues, setFormValues] = useState(props.current_folder);
  const location = useLocation();
  const context = useContext(UserContext);
  const { currentUser } = context;
  const installationContext = useContext(InstallationsContext);
  const { setError } = installationContext;

  useEffect(() => {
    setFormValues(props.current_folder);
  }, [props.current_folder]);

  useEffect(() => {
    let path = location.pathname.split('/');

    setCurrentTab(path[path.length - 1]);
  }, [location]);

  if (formValues == undefined) {
    return null;
  }

  const tabs = [
    {
      value: 'information',
      label: <FormattedMessage id="information" defaultMessage="Information" />
    },
    {
      value: 'manage',
      label: (
        <FormattedMessage id="manageAccess" defaultMessage="Manage Access" />
      )
    }
  ];

  const handleTabsChange = (_event: ChangeEvent<{}>, value: string): void => {
    setCurrentTab(value);
    setError(false);
  };

  return (
    <>
      <Grid item xs={12} md={12}>
        <TabsContainerWrapper>
          <Tabs
            onChange={handleTabsChange}
            value={currentTab}
            variant="scrollable"
            scrollButtons="auto"
            textColor="primary"
            indicatorColor="primary"
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                label={tab.label}
                value={tab.value}
                component={Link}
                to={
                  location.pathname.substring(
                    0,
                    location.pathname.lastIndexOf('/') + 1
                  ) + routes[tab.value]
                }
              />
            ))}
          </Tabs>
        </TabsContainerWrapper>
        <Card variant="outlined">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={0}
          >
            <Routes>
              <Route
                path={routes.information}
                element={
                  <TreeInformation
                    folder={props.current_folder}
                  ></TreeInformation>
                }
              />
              {currentUser.userType == UserType.admin && (
                <Route
                  path={routes.manage}
                  element={
                    <AccessContextProvider>
                      <Access
                        currentResource={formValues}
                        resourceType="folder"
                      ></Access>
                    </AccessContextProvider>
                  }
                />
              )}
            </Routes>
          </Grid>
        </Card>
      </Grid>
    </>
  );
}

export default Folder;
